import { useEffect } from 'react';
export default function AdminSiteRedirect({ path }: { path: string }) {
  useEffect(() => { window.location.replace('https://admin.easyride.tw' + path); }, [path]);
  return <p>管理功能已移至 <a href={'https://admin.easyride.tw' + path}>Easyride 管理中心</a>。</p>;
}
